import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <div class="poem">

      <p class="poem-block mb-3">
        Freneziĝas mondo senkompata, <br/>
        Ĉie stres’, malico kaj mizer’, <br/>
        La plimulto kruda kaj malsata, <br/>
        Luksa viv’ – nur por malgranda er’
      </p>

      <p class="poem-block mb-3">
        De l’ homar’. Senĉese ĝi trompata <br/>
        Restas, kaj apenaŭ la esper’ <br/>
        Venas al animo malbeata, <br/>
        Kie regas zorgoj kaj koler’.
      </p>

      <p class="poem-block mb-3">
        Sed estas viv’ alia apud hom’. <br/>
        Kiam revenas li al sia dom’, <br/>
        Azilo kontraŭ ajna sortobato,
      </p>

      <p class="poem-block mb-3">
        Renkontas lin kun amo kaj fidel’ <br/>
        Amik’ sincera kun la vila fel’ – <br/>
        Fiera, nobla, eleganta  KATO!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Soneto pri kato'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;